import './App.css';

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import useLocalStorage from 'use-local-storage';

import Sidebar from './components/sidebar/Sidebar';
import Home from './components/home/Home';
import About from './components/about/About';
import Services from './components/services/Services';
import Resume from './components/resume/Resume';
import Portfolio from './components/portfolio/Portfolio';
import Testimonials from './components/testimonials/Testimonials';
import Blog from './components/blog/Blog';
import Contact from './components/contact/Contact';
import SanctuaryLanding from './pages/sanctuary/SanctuaryLanding';
import SanctuaryPrivacy from './pages/sanctuary/SanctuaryPrivacy';
import SanctuaryTerms from './pages/sanctuary/SanctuaryTerms';
import SanctuaryRefund from './pages/sanctuary/SanctuaryRefund';

function HomeView({ theme }) {
  return (
    <main className="main">
      <Home />
      <About />
      <Services />
      <Resume />
      <Portfolio />
      <Testimonials />
      <Blog />
      <Contact theme={theme} />
    </main>
  );
}

function AppShell({ theme, switchTheme }) {
  const { pathname } = useLocation();
  const hideSidebar = pathname.startsWith('/projects/sanctuary');

  return (
    <div className="app" data-theme={theme}>
      {!hideSidebar && <Sidebar theme={theme} switchTheme={switchTheme} />}
      <Routes>
        <Route path="/" element={<HomeView theme={theme} />} />
        <Route path="/projects/sanctuary" element={<SanctuaryLanding />} />
        <Route path="/projects/sanctuary/privacy" element={<SanctuaryPrivacy />} />
        <Route path="/projects/sanctuary/terms" element={<SanctuaryTerms />} />
        <Route path="/projects/sanctuary/refund" element={<SanctuaryRefund />} />
      </Routes>
    </div>
  );
}

function App() {
  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [theme, setTheme] = useLocalStorage('theme', defaultDark ? 'dark' : 'light');

  const switchTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
  };

  return (
    <BrowserRouter>
      <AppShell theme={theme} switchTheme={switchTheme} />
    </BrowserRouter>
  );
}

export default App;
